import { StyleProp, Text, TextProps, TextStyle } from "react-native";

import { FONT_FAMILY } from "../../common/styles";
import React from "react";

interface PropsType {
  style?: StyleProp<TextStyle>;
  text?: string | number;
  props?: TextProps;
  children?: JSX.Element | string | number;
}

const NSText = ({ style, text, props, children }: PropsType) => {
  return (
    <Text style={[{ fontFamily: FONT_FAMILY.notosans }, style]} {...props}>
      {text || children}
    </Text>
  );
};

export default NSText;
